(function () {
  if (window.__3ideeSetupCta) return;
  window.__3ideeSetupCta = true;

  var SCHLUESSEL = '3idee_auswahl';

  function alleKnoepfe() { return document.querySelectorAll('.header-setup-cta'); }
  function alleWahlen() { return document.querySelectorAll('[data-setup-wahl]'); }
  if (!alleWahlen().length) return;

  function auswahl() {
    try {
      var roh = localStorage.getItem(SCHLUESSEL);
      if (!roh) return null;
      var a = JSON.parse(roh);
      return (a && a.name) ? a : null;
    } catch (e) { return null; }
  }

  function zeichnen() {
    var a = auswahl();

    alleKnoepfe().forEach(function (k) { k.hidden = !!a; });

    alleWahlen().forEach(function (w) {
      w.hidden = !a;
      if (!a) return;

      var name = w.querySelector('[data-setup-name]');
      var mehr = w.querySelector('[data-setup-mehr]');
      if (name) name.textContent = a.name;
      if (mehr) {
        var weitere = (a.anzahl || 1) - 1;
        mehr.hidden = weitere < 1;
        mehr.textContent = weitere > 0 ? '+' + weitere : '';
      }
    });

    document.querySelectorAll('[data-setup-panelname]').forEach(function (el) {
      if (a) el.textContent = a.anzahl > 1 ? a.name + ' +' + (a.anzahl - 1) : a.name;
    });

    document.querySelectorAll('[data-setup-titel]').forEach(function (el) {
      if (!a) return;
      el.textContent = (a.anzahl === 1)
        ? (el.getAttribute('data-einer') || 'Dein Monitor')
        : (el.getAttribute('data-mehrere') || 'Deine Monitore');
    });
  }

  function menueZu(w) { return (w && w.querySelector('[data-setup-menue]')) || menueVon(w); }
  function menueVon(w) {
    var alle = document.querySelectorAll('[data-setup-menue]');
    for (var i = 0; i < alle.length; i++) if (alle[i].__wahl === w) return alle[i];
    return null;
  }

  function menueSchliessen() {
    document.querySelectorAll('[data-setup-menue]').forEach(function (m) {
      if (!m.hidden) m.hidden = true;
    });
    document.querySelectorAll('[data-setup-pfeil]').forEach(function (p) {
      p.setAttribute('aria-expanded', 'false');
    });
  }

  function menueOeffnen(w, pfeil, menue) {
    menueSchliessen();

    if (menue.parentNode !== document.body) {
      menue.__wahl = w;
      document.body.appendChild(menue);
    }

    menue.hidden = false;
    pfeil.setAttribute('aria-expanded', 'true');

    var r = pfeil.getBoundingClientRect();
    var breite = menue.offsetWidth || 190;
    menue.style.position = 'fixed';
    menue.style.top = Math.round(r.bottom + 6) + 'px';
    menue.style.left = Math.round(Math.max(8, Math.min(r.right - breite, window.innerWidth - breite - 8))) + 'px';
    menue.style.right = 'auto';
  }

  document.addEventListener('click', function (e) {
    zeichnen();
    setTimeout(zeichnen, 250);

    var pfeil = e.target.closest && e.target.closest('[data-setup-pfeil]');
    if (pfeil) {
      e.preventDefault();
      e.stopPropagation();
      var w = pfeil.closest('[data-setup-wahl]');
      var menue = menueZu(w);
      if (!menue) return;
      if (menue.hidden) menueOeffnen(w, pfeil, menue);
      else menueSchliessen();
      return;
    }
    if (!e.target.closest || !e.target.closest('[data-setup-menue]')) menueSchliessen();
  }, true);

  window.addEventListener('resize', menueSchliessen);
  window.addEventListener('scroll', menueSchliessen, { passive: true });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') menueSchliessen(); });

  document.addEventListener('click', function (e) {
    var neu = e.target.closest && e.target.closest('[data-setup-neu]');
    if (neu) {
      (function () {
        try { localStorage.removeItem(SCHLUESSEL); } catch (e) {}
        try {
          Object.keys(sessionStorage).forEach(function (k) {
            if (k.indexOf('fn3state:') === 0) sessionStorage.removeItem(k);
          });
        } catch (e) {}

        var menue = neu.closest('[data-setup-menue]');
        var w = (menue && menue.__wahl) || document.querySelector('[data-setup-wahl]');
        var ziel = w && w.querySelector('[data-setup-ziel]');
        window.location.href = ziel ? ziel.getAttribute('href') : '/';
      })();
    }
  }, true);

  zeichnen();

  if (window.MutationObserver) {
    var beobachter = new MutationObserver(function (eintraege) {
      for (var i = 0; i < eintraege.length; i++) {
        var dazu = eintraege[i].addedNodes;
        for (var j = 0; j < dazu.length; j++) {
          var n = dazu[j];
          if (!n || n.nodeType !== 1 || !n.matches) continue;
          if (n.matches('.header-setup-cta, [data-setup-wahl]') ||
              n.querySelector('.header-setup-cta, [data-setup-wahl]')) {
            zeichnen();
            return;
          }
        }
      }
    });
    beobachter.observe(document.body, { childList: true, subtree: true });
  }

  document.addEventListener('finder:auswahl', zeichnen);
  window.addEventListener('storage', function (e) { if (e.key === SCHLUESSEL) zeichnen(); });
  window.addEventListener('pageshow', zeichnen);
})();
